import { gql } from '@apollo/client';

export const GetActiveTestQuery = gql`
    query GetActiveTest {
        getActiveOLTest {
            name
            exists
            subjectId
            isSubject
        }
    }
`;
